// features/workstations/components/recent-activity.js
// ═══════════════════════════════════════════════════════════
// RECENT ACTIVITY — cross-Workstation event feed
//
// Bottom row of the Workstation Home. Shows the 5-10 most
// recent activity events across all the user's Workstations.
// Click any event → jumps to that Workstation directly into
// the relevant tab (wired in Phase 3+).
// ═══════════════════════════════════════════════════════════

export default function RecentActivity({ events = [], onEventClick }) {
  if (events.length === 0) return null;
  return (
    <div className="ws-recent">
      <div className="ws-recent-header">Recent Activity — across all Workstations</div>
      {events.map((ev, i) => (
        <div
          key={i}
          className="ws-recent-row"
          onClick={() => onEventClick?.(ev)}
          role="button"
          tabIndex={0}
        >
          <div className="ws-recent-time">{relativeTime(ev.created_at)}</div>
          <div className="ws-recent-ws-name">{ev.workstation_name || '—'}</div>
          <div className="ws-recent-summary">{ev.summary || formatEventType(ev.event_type)}</div>
        </div>
      ))}
    </div>
  );
}

function formatEventType(type) {
  const labels = {
    chat_message:   'Chat message',
    upload:         'File uploaded',
    finding:        'Finding captured',
    work_save:      'Work saved',
    session_open:   'Session opened',
    session_close:  'Session closed',
  };
  return labels[type] || type;
}

function relativeTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const ageMs = Date.now() - d.getTime();
  const ageMin = Math.floor(ageMs / 60000);
  if (ageMin < 1) return 'Just now';
  if (ageMin < 60) return `${ageMin}m ago`;
  const ageHr = Math.floor(ageMin / 60);
  if (ageHr < 24) {
    // Show time for today
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }
  const ageDay = Math.floor(ageHr / 24);
  if (ageDay === 1) return 'Yesterday';
  if (ageDay < 7) return `${ageDay}d ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
